package com.essntl.uikit.components.chat.message

import com.essntl.uikit.components.chat.contact.ContactUiState

data class MessageUiState(
    val id: String,
    val text: String,
    val isCurrentUserSender: Boolean,
    val contact: ContactUiState,
    val senderName: String?,
    val dateTime: String,
    val reactions: List<Reaction>,
    val linkPreview: LinkPreview?,
    val status: Status?,
    val type: Type?,
) {
    data class Reaction(
        val type: String,
        val emoji: String?,
        val from: String,
        val fromName: String?,
        val fromMe: Boolean,
    )

    data class LinkPreview(
        val body: String,
        val url: String,
    )

    enum class Type {
        Text, Call
    }

    enum class Status {
        Pending, Delivered, Read
    }

    companion object {
        val empty =
            MessageUiState(
                id = "",
                text = "",
                isCurrentUserSender = false,
                contact = ContactUiState.empty,
                senderName = null,
                dateTime = "",
                reactions = emptyList(),
                linkPreview = null,
                status = null,
                type = null
            )
    }
}
